import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalSelectMapBoxItem.module.scss';

interface Props {
	value: string;
	isSelected: boolean;
	isHidden: boolean;
	onClick: () => void;
}

const DENTModalOverviewPeriodontalSelectMapBoxItem = ({
	value,
	isSelected,
	isHidden,
	onClick,
}: Props) => {
	return (
		<span
			className={joinClasses([
				styles.item,
				isSelected ? styles.selected : '',
				isHidden ? styles.hidden : '',
			])}
			onClick={onClick}>
			{value}
		</span>
	);
};

export default DENTModalOverviewPeriodontalSelectMapBoxItem;
